import file from './file';
import auth from './auth';
import register from './register';
import lots from './lots';
import user from './user';
import admin from './admin';
import pub from './pub';
import contracts from './contracts';
import contractWorks from './contractworks';
import protocols from './protocols';
import supplyRequest from './supplyRequest';
import supplyTask from './supplyTask';
import receiptOrder from './receiptOrder';
import clarifications from './clarifications';
import notification from './notification';
import helpers from './helpers';
import gencontractor from './gencontractor';

export default {
  file,
  auth,
  register,
  lots,
  admin,
  user,
  pub,
  contracts,
  protocols,
  supplyRequest,
  supplyTask,
  receiptOrder,
  clarifications,
  notification,
  helpers,
  gencontractor,
  contractWorks,
};
